import { GETO_MOBILE_ACCESS_CODE, GETO_PC_ACCESS_CODE } from "@/consts";
import { useMounted } from "@/hooks/useMounted";
import { getAccessCode } from "@/lib/utils";
import LoginblockPage from "@/pages/Loginblock";
import { createFileRoute, useRouterState } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/loginblock/")({
  component: RouteComponent,
});

function RouteComponent() {
  // searchparam에서 state얻기
  const { state } = useRouterState({
    select: (s) => s.location.search,
  });
  const mounted = useMounted();

  useEffect(() => {
    const accessCode = getAccessCode();

    if (!mounted) return;
    else if (accessCode === GETO_PC_ACCESS_CODE || accessCode === GETO_MOBILE_ACCESS_CODE) return;

    const script = document.createElement("script");
    script.src = import.meta.env.VITE_NEXON_GNB_URL;
    script.async = true;
    script.dataset.gamecode = "65533";
    script.dataset.ispublicbanner = "false";
    script.dataset.minwidth = "360";
    script.dataset.skiptocontentsid = "skipToContent";
    script.dataset.onAuthSuccessRedirectUrl = import.meta.env.VITE_NEXON_COM_URL;
    script.dataset.loginenv = import.meta.env.VITE_GNB_LOGIN_ENV;
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, [mounted]);

  return <LoginblockPage state={state} />;
}
